<ion-header>
  <ion-toolbar color="dark">
    <ion-buttons slot="start">
      <ion-button size="small"  class="back-button"  (click)="dismiss()" >{{ 'BACK' | translate }}</ion-button>
    </ion-buttons>
    <ion-title class="title-text" color="primary">{{'SETTINGS' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">

  <ion-row>
    <ion-title *ngIf="!changePassword" color="primary" (click)="onClickPassword()">{{"PASSWORD.CHANGE" | translate}} <ion-icon name="create-outline"></ion-icon></ion-title>
    <ion-list *ngIf="changePassword" class="password">

      <ion-item>
        <ion-label position="floating">{{"PASSWORD.CHANGE.ACTIVATE" | translate}}</ion-label>
        <ion-input [type]="hideOld ? 'password' : 'text'" [(ngModel)]="userPasswordForm.oldPassword" required aria-label="Old Password">
          <ion-icon slot="end" [name]="hideOld ? 'eye-off' : 'eye'" (click)="hideOld = !hideOld"></ion-icon>
        </ion-input>

        @if(userPasswordForm.oldPassword != userPasswordForm.oldPassword) {
          <small>
            <ion-text color="danger">{{"PASSWORD.DIFFERENT" | translate}}</ion-text>
          </small>
        }

      </ion-item>

      <ion-item>
        <ion-label position="floating">{{"PASSWORD.NEW_PASSWORD" | translate}}</ion-label>
        <ion-input minlength="6" [type]="hideNew ? 'password' : 'text'" [(ngModel)]="userPasswordForm.newPassword" required aria-label="New Password">
          <ion-icon slot="end" [name]="hideNew ? 'eye-off' : 'eye'" (click)="hideNew = !hideNew"></ion-icon>
        </ion-input>

        @if(userPasswordForm.newPassword.length < 6 && userPasswordForm.newPassword.length > 0) {
          <small>
            <ion-text color="danger">{{"PASSWORD.LENGTH.REQUIRED" | translate}}</ion-text>
          </small>
        }

      </ion-item>

      <ion-item>
        <ion-label position="floating">{{"PASSWORD.REPEAT" | translate}}</ion-label>
        <ion-input minlength="8" [type]="hideConfirm ? 'password' : 'text'" [(ngModel)]="userPasswordForm.newPasswordConfirm" (ionChange)="onChangeEditPasswordForm()" required aria-label="Retype New Password">
          <ion-icon slot="end" [name]="hideConfirm ? 'eye-off' : 'eye'" (click)="hideConfirm = !hideConfirm"></ion-icon>
        </ion-input>

        @if (userPasswordForm.newPassword != userPasswordForm.newPasswordConfirm) {
          <small>
            <ion-text color="danger">{{"PASSWORD.NO_MATCH" | translate}}</ion-text>
          </small>
        }
      </ion-item>

      <ion-note slot="helper">{{"PASSWORD.LENGTH.REQUIRED" | translate}}</ion-note>
      <ion-button size="small" (click)="onClickSavePassword()">{{"PASSWORD.CHANGE" | translate}}</ion-button>
    </ion-list>
  </ion-row>
   <!-- TODO: Activate this option when the services is done -->
  <!-- <ion-row class="location">
    <ion-title color="primary">Location Detection</ion-title>
    <ion-toggle [checked]="locDetect" (ionChange)="changeDetection($event)"></ion-toggle>
    <ion-note>Automatic weight and gas station detection</ion-note>
  </ion-row> -->
</ion-content>
